import { render, staticRenderFns } from "./BulkEditModal.vue?vue&type=template&id=7c35498e&scoped=true"
import script from "./BulkEditModal.vue?vue&type=script&lang=js"
export * from "./BulkEditModal.vue?vue&type=script&lang=js"
import style0 from "./BulkEditModal.vue?vue&type=style&index=0&id=7c35498e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c35498e",
  null
  
)

export default component.exports